import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  IconButton,
  Dialog,
  DialogContent,
  Autocomplete,
  TextField,
  Checkbox,
  Button,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import { toMoney } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { Circle } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import { UseMotorDelivery } from "./UseMotorDelivery";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import { useSnackbar } from "notistack";

export default function OrdersListGrid(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { enqueueSnackbar } = useSnackbar();
  const { setDeliverOrders, SendOrderSort, PickupToDriver } =
    UseMotorDelivery();
  const location = useLocation();
  const navigate = useNavigate();
  const [states, setStates] = useState([
    { id: 1, value: "تحویل" },
    { id: 2, value: "مرجوع" },
  ]);
  const [ordersRes, setOrdersRes] = useState([]);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [filt, setFilt] = useState([]);
  const [openDialogFinal, setOpenDialogFinal] = useState(false);
  const [forExcel, setForExcel] = useState([]);
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const [sendState, setSendState] = useState({
    orderID: [],
    state: undefined,
    driverID: undefined,
  });
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchSubGroup, setSearchSubGroup] = useState(
    location.state && location.state.searchSubGroup
      ? location.state.searchSubGroup
      : ""
  );

  useEffect(() => {
    if (props.rows) {
      setSendState({ ...sendState, driverID: props.rows.driverID });
      setOrdersRes(props.rows);
    }
  }, [props.rows]);

  useEffect(() => {
    if (props.rows && openDialogFinal) {
      let temp = forExcel;
      props.rows.orders.map((m) => {
        temp.push(m.orderID);
      });
      setForExcel(temp);
      setSendState({ ...sendState, orderID: temp });
    }
  }, [props.rows, openDialogFinal]);

  const funcPickup = () => {
    let model = {
      deliveryDate: props.filters.deliveryDate,
      deliveryPart: props.filters.deliveryPart,
      driverID: ordersRes.driverID,
    };
    PickupToDriver(model, (callback) => props.callback(ordersRes.driverID));
  };

  const funcFinalApproval = () => {
    setOpenDialogFinal(true);
  };

  const funcPrint = () => {
    return navigate("/motordelivery/OrderPrint", {
      state: {
        ordersRes: ordersRes,
      },
    });
  };

  useEffect(() => {
    setFilt([
      {
        columnField: "orderID",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "orderID",
      width: 100,
      align: "center",
      headerName: "سفارش",
      headerAlign: "center",
    },
    {
      field: "customer",
      headerName: "نام",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.customer}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "موبایل",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return <Typography variant="span">{cellValues.row.mobile}</Typography>;
      },
    },
    {
      field: "neighbourhood",
      headerName: "محله",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.neighbourhood}
          </Typography>
        );
      },
    },
    {
      field: "address",
      headerName: "آدرس",
      width: 400,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: ".8rem",
            }}
          >
            {cellValues.row.address}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 100,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <IconButton
              sx={{ mr: 0.5 }}
              onClick={() => {
                let model = {
                  deliveryDate: props.filters.deliveryDate,
                  deliveryPart: props.filters.deliveryPart,
                  driverID: ordersRes.driverID,
                  orderID: cellValues.row.orderID,
                  order: cellValues.row.id - 1,
                };
                if (cellValues.row.id - 1 == 0) {
                  return;
                } else {
                  SendOrderSort(model, () => {
                    props.callback(model.driverID);
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{}}
              onClick={() => {
                let model = {
                  deliveryDate: props.filters.deliveryDate,
                  deliveryPart: props.filters.deliveryPart,
                  driverID: ordersRes.driverID,
                  orderID: cellValues.row.orderID,
                  order: cellValues.row.id + 1,
                };

                if (cellValues.row.id + 1 == ordersRes.orders.length + 1) {
                  return;
                } else {
                  SendOrderSort(model, () => {
                    props.callback(model.driverID);
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
  ];

  const columns2 = [
    {
      field: "Checkbox",
      width: 50,
      align: "center",
      headerAlign: "center",
      sortable: false,
      headerName: "چکباکس",
      renderCell: (cellValues) => {
        return (
          <Checkbox
            checked={forExcel.includes(cellValues.row.orderID)}
            onChange={(event) => {
              let temp = forExcel;
              if (event.target.checked) {
                temp.push(cellValues.row.orderID);
              } else if (event.target.checked == false) {
                temp = forExcel.filter((m) => m !== cellValues.row.orderID);
              }
              setForExcel(temp);
              setSendState({ ...sendState, orderID: temp });
            }}
          />
        );
      },
      renderHeader: (cellValues) => {
        return (
          <Checkbox
            checked={sendState.orderID.length == ordersRes.orders.length}
            onChange={(event) => {
              let temp = forExcel;
              if (event.target.checked == true) {
                props.rows?.orders?.map((m) => {
                  temp.push(m.orderID);
                });
                setForExcel(temp);
              } else if (event.target.checked == false) {
                temp = [];
                setForExcel([]);
              }
              setSendState({ ...sendState, orderID: temp });
            }}
          />
        );
      },
    },
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "orderID",
      width: 120,
      align: "center",
      headerName: "سفارش",
      headerAlign: "center",
    },
    {
      field: "search",
      width: 200,
      align: "center",
      headerName: "جستجو",
      sortable: false,
      headerAlign: "center",
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو"
            size="small"
            variant="outlined"
            value={searchState}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              if (evt.target.value == "") {
                setSearchSubGroup("");
              }
              setSearchState(evt.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setSearchSubGroup(searchState);
              }
            }}
          />
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "90%" }}>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        // maxWidth=""
        open={openDialogFinal}
        onClose={() => {
          setOpenDialogFinal(false);
          setForExcel([]);
          setSendState({
            ...sendState,
            state: undefined,
            orderID: [],
          });
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          <Box sx={{ height: "30rem", width: "100%" }}>
            {ordersRes ? (
              <DataGrid
                filterModel={{
                  items: filt,
                }}
                className="ltr-grid"
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns2}
                rows={ordersRes.orders ? ordersRes.orders : []}
                page={pageState.page - 1}
                pageSize={20}
                Pagination
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...pageState, page: newPage + 1 }));
                }}
                rowCount={
                  ordersRes.orders && ordersRes.orders.length
                    ? ordersRes.orders.length
                    : 1
                }
                disableVirtualization
                enableRangeSelection={true}
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    isLtr: true,
                    nofab: true,
                    // noPage: true,
                    rowCount:
                      ordersRes.orders && ordersRes.orders.length
                        ? ordersRes.orders.length
                        : "",
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: "rowIndex",
                        sort: "asc",
                      },
                    ],
                  },
                }}
              />
            ) : (
              <ProgressCom />
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Autocomplete
              size="small"
              // value={props.assignModel.driverID ? props.assignModel.driverID : ""}
              onChange={(event, newValue) => {
                if (newValue) {
                  setSendState({
                    ...sendState,
                    state: newValue,
                  });
                } else {
                  setSendState({
                    ...sendState,
                    state: undefined,
                  });
                }
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return states?.find((m) => m.id == option).value;
                }
                return "";
              }}
              sx={{ width: "40%" }}
              options={states?.map((m) => m.id)}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="وضعیت" />
              )}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  if (!sendState.state) {
                    enqueueSnackbar("وضعیت را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  if (sendState.orderID.length == 0) {
                    enqueueSnackbar("سفارشی را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  setCheckState({ name: "ثبت نهایی", show: true });
                }}
              >
                ثبت
              </Button>
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setOpenDialogFinal(false);
                  setForExcel([]);
                  setSendState({
                    ...sendState,
                    state: undefined,
                    orderID: [],
                  });
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <Typography variant="subtitle1" color="secondary" sx={{ mb: 2 }}>
        لیست سفارشات
      </Typography>
      {ordersRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={ordersRes.orders ? ordersRes.orders : []}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={
            ordersRes.orders && ordersRes.orders.length
              ? ordersRes.orders.length
              : 1
          }
          disableVirtualization
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              funcPickup: funcPickup,
              funcPrint: funcPrint,
              funcFinalApproval: funcFinalApproval,
              isLtr: true,
              nofab: true,
              orderRes: ordersRes,
              pickup: ordersRes?.pickup,
              FinalApproval: ordersRes?.pickup,
              logesticButtons: true,
              rowCount:
                ordersRes.orders && ordersRes.orders.length
                  ? ordersRes.orders.length
                  : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "rowIndex",
                  sort: "asc",
                },
              ],
            },
          }}
        />
      ) : (
        <ProgressCom />
      )}
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          setProgress(true);
          setDeliverOrders(sendState, () => {
            setOpenDialogFinal(false);
            setForExcel([]);
            setSendState({
              ...sendState,
              state: undefined,
              orderID: [],
            });
          });
        }}
      />
    </Box>
  );
}
